import { render, staticRenderFns } from "./rel-receita-5-itens.vue?vue&type=template&id=82b8b7cc&scoped=true&"
import script from "./rel-receita-5-itens.vue?vue&type=script&lang=js&"
export * from "./rel-receita-5-itens.vue?vue&type=script&lang=js&"
import style0 from "./rel-receita-5-itens.vue?vue&type=style&index=0&id=82b8b7cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b8b7cc",
  null
  
)

export default component.exports